'use client';
import { useState } from 'react';

import { ArrowDown } from '../../../../public/Images';
import RadioBoxSimple from '@/components/shared/radio-box-simple-v2/radio-box-simple.component';
import CheckBoxGroup from '@/components/shared/checkbox-group/checkbox-group.component';
import Typography from '@/components/shared/typography/typography.component';
import { useWindowDimensions } from '@/hook';
import { MakeFilterUiOject } from '@/types';
import { FilterMultiSelect } from '@/components/filtersV2';

import Image from 'next/image';
import myImageLoader from '@/image.loader';
import { TFilterGroupOtherProps } from '@/components/filtersV2/filter-group/filter-group.component.types';

const FilterGroupOther = ({
    data,
    filterType,
    filterItemClicked,
    label,
    makeModelClicked,
    containerExtraCssClass = '',
}: TFilterGroupOtherProps) => {
    const [isOpen, setIsOpen] = useState(true);
    const { IS_DESKTOP } = useWindowDimensions();

    const makeModelValueChanged = (vehicle: {
        make: string;
        model: string;
    }) => {
        if (makeModelClicked) {
            makeModelClicked(vehicle);
        }
    };

    return (
        <div
            className="w-full py-3 overflow-y-auto overflow-x-hidden"
            style={{
                position: 'relative',
                paddingBottom: '',
                padding: IS_DESKTOP ? '' : 0,
                overflowX: IS_DESKTOP ? 'hidden' : 'inherit',
            }}
        >
            <div className="flex items-center justify-between mb-5">
                <Typography className="text-gray-700" variant={'captionMedium'}>
                    {label}
                </Typography>
                {IS_DESKTOP && (
                    <Image
                        src={ArrowDown.src}
                        width={18}
                        height={18}
                        alt="Toggle dropdown"
                        onClickCapture={() => setIsOpen(!isOpen)}
                        style={{
                            width: '16px',
                            transform: isOpen ? 'scaleY(-1)' : 'scaleY(1)',
                            cursor: 'pointer',
                        }}
                    />
                )}
            </div>

            {(filterType === 'checkbox' || filterType === 'radiobox') && (
                <div
                    className={`overflow-auto ${
                        isOpen ? ` lg:${containerExtraCssClass} ` : ' lg:h-0'
                    }`}
                    style={{
                        height: isOpen ? 'fit-content' : '0',
                        transition: 'height ease-out 0.5s',
                    }}
                >
                    {data.map(item => {
                        if (filterType === 'checkbox')
                            return (
                                <div
                                    className="mb-2"
                                    key={
                                        typeof item.text === 'string'
                                            ? item.text
                                            : item.value
                                    }
                                >
                                    <CheckBoxGroup
                                        text={item.text}
                                        selected={item.selected}
                                        value={item.value as string}
                                        checkBoxClicked={filterItemClicked}
                                    />
                                </div>
                            );
                        if (filterType === 'radiobox')
                            return (
                                <div
                                    className="mb-2"
                                    key={
                                        typeof item.text === 'string'
                                            ? item.text
                                            : item.value
                                    }
                                >
                                    <RadioBoxSimple
                                        text={item.text}
                                        value={item.value as string}
                                        icon={item.icon}
                                        description={item.description}
                                        selected={item.selected}
                                        isNew={item.isNew}
                                        radioBoxClicked={filterItemClicked}
                                    />
                                </div>
                            );
                        return '';
                    })}
                </div>
            )}
            {filterType === 'multiSelect' && (
                <div
                    className={`overflow-auto ${
                        isOpen ? ` lg:${containerExtraCssClass} ` : ' lg:h-0'
                    }`}
                    style={{
                        height: isOpen ? 'fit-content' : '0',
                        transition: 'height ease-out 0.5s',
                    }}
                >
                    {(data as MakeFilterUiOject[]).map(item => (
                        <div className="mb-2" key={item.text}>
                            <FilterMultiSelect
                                text={item.text}
                                value={item.value}
                                selected={item.selected}
                                img={myImageLoader({
                                    src: `https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/${item.text}.jpg`,
                                    quality: 85,
                                    width: 28,
                                    height: 28,
                                })}
                                checkBoxClicked={makeModelValueChanged}
                                dropdownData={item}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default FilterGroupOther;
